/**
 * defa.views.PhoneNumberCollectionView
 * A view to list several PhoneNumbers with.
 * @version 1.2.0
 */
import PhoneNumberSnippet from 'scripts/defa/phone-numbers/view-phone-number-snippet';
import CollectionView     from 'scripts/poppet/collection-view';

const PhoneNumberCollectionView = CollectionView.extend( {
	
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	childView: PhoneNumberSnippet,
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default PhoneNumberCollectionView;